module.exports = __webpack_public_path__ + "img/c2.a2ab3b8d.jpg";